module.exports = __webpack_public_path__ + "static/favicon-298debe9b9124eb94c1df0254b5d64c8.png";